import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const SuccessDialog = ({
    visible,
    onHide,
    header = "Success",
    message = "Action completed successfully!",
    buttonLabel = "OK"
}) => {

    const dialogHeaderStyle = {
        backgroundColor: "#4CAF50",
        padding: "15px 15px",
        color: "white",
        fontWeight: "600",
        fontSize: "1.25rem",
        borderTopLeftRadius: "6px",
        borderTopRightRadius: "6px",
        fontFamily: "var(--font-h3)",
        // fontSize: "var(--h3-font-size)"
    };

    const dialogContentStyle = {
        padding: "10px 15px",
        fontSize: "var(--paragraph-font-size)",
        fontFamily: "var(--font-paragraph)",
        textAlign: "center",
        color: "#444",
        lineHeight: "1.6",
    };

    const dialogFooterStyle = {
        display: "flex",
        justifyContent: "flex-end",
        padding: "0px 15px 15px 15px",
    };

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            position="top"
            header={<div style={dialogHeaderStyle}>{header}</div>}
            style={{
                width: "400px",
                top: "1rem",
                borderRadius: "12px",
                boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.15)",
            }}
            draggable={false}
            closable={false}
        >
            <div style={dialogContentStyle}>
                {message}
            </div>
            <div style={dialogFooterStyle}>
                <Button
                    label={buttonLabel}
                    onClick={onHide}
                    style={{
                        backgroundColor: "#4caf50",
                        border: "none",
                        padding: "0.5rem 1.5rem",
                        fontWeight: "600",
                        fontSize: "1rem",
                        color: "#fff",
                        borderRadius: "6px",
                    }}
                />
            </div>
        </Dialog>
    );
};

export default SuccessDialog;
